import { svg } from 'omni-ui';

const contents = {
  square: svg`<rect width="100" height="100" class="toolbox-button-shape" />`,
  circle: svg`<circle cx="50" cy="50" r="50" class="toolbox-button-shape" />`,
  triangle: svg`<polygon
    points="50 0, 100 100, 0 100"
    class="toolbox-button-shape"
  />`,
  diamond: svg`<polygon
    points="50 0, 100 50, 50 100, 0 50"
    class="toolbox-button-shape"
  />`,
  text: svg`<text x="50" y="50" dominant-baseline="middle" text-anchor="middle" class="toolbox-button-text">ABC</text>`,
  line: svg`
    <path fill-rule="evenodd" clip-rule="evenodd" d="M6 49L90 49V52L6 52L6 49Z" class="toolbox-button-line" />
  `,
  lineArrow: svg`
    <path d="M92.4186 49.625C93.1064 50.0056 93.1064 50.9944 92.4186 51.375L77.4841 59.6381C76.8176 60.0069 76 59.5249 76 58.7631V42.2369C76 41.4751 76.8176 40.9931 77.4841 41.3619L92.4186 49.625Z" class="toolbox-button-line" />
    <path fill-rule="evenodd" clip-rule="evenodd" d="M6 49L90 49V52L6 52L6 49Z" class="toolbox-button-line" />
  `,
  dashedLine: svg`
    <path fill-rule="evenodd" clip-rule="evenodd" d="M87 49L90 49L90 52L87 52L87 49ZM75 49L81 49L81 52L75 52L75 49ZM63 49L69 49L69 52L63 52L63 49ZM51 49L57 49L57 52L51 52L51 49ZM39 49L45 49L45 52L39 52L39 49ZM27 49L33 49L33 52L27 52L27 49ZM15 49L21 49L21 52L15 52L15 49ZM6 49L9 49L9 52L6 52L6 49Z" class="toolbox-button-line" />
  `,
  thickLine: svg`
  <path fill-rule="evenodd" clip-rule="evenodd" d="M8 47L92 47L92 54L8 54L8 47Z" class="toolbox-button-line" />
  `,
  orthogonalLine: svg``,
  orthogonalLineArrow: svg``,
  /** @todo: Audit - scaled this since it needed converted from zeplin and was at 51/51, I think this is an available omni-icon */
  image: svg`<g transform="scale(1.95, 1.95)" class="toolbox-button-image" fill-rule="nonzero">
    <path d="M32.508 1.631H3.34c-.863 0-1.563.7-1.563 1.563v32.083c0 .863.7 1.563 1.563 1.563h29.167c.863 0 1.562-.7 1.562-1.563V3.194c0-.863-.7-1.563-1.562-1.563zm-1.564 3.125v28.958H4.904V4.756h26.04z"/>
    <path d="M32.508 24.965a1.562 1.562 0 0 1 .182 3.114l-.182.01H3.34a1.562 1.562 0 0 1-.182-3.114l.182-.01h29.167z"/>
    <path d="M36.869 13.357a1.563 1.563 0 0 1 1.8-1.036l.176.048 7.744 2.58a3.02 3.02 0 0 1 1.982 3.566l-.073.256-9.223 27.67a3.02 3.02 0 0 1-3.566 1.983l-.255-.073-20.93-6.977a1.563 1.563 0 0 1 .811-3.012l.176.047 20.831 6.944L45.5 17.88l-7.643-2.547a1.563 1.563 0 0 1-1.036-1.8l.048-.177z"/>
    <path d="M22.31 12.19a4.479 4.479 0 0 1 3.399 1.294l.216.23 7.759 8.868a1.563 1.563 0 0 1-2.214 2.197l-.138-.14-7.76-8.868a1.354 1.354 0 0 0-2.02-.022l-.111.14-8.07 11.534a1.562 1.562 0 0 1-2.663-1.624l.103-.167 8.068-11.534a4.48 4.48 0 0 1 3.43-1.909zM11.727 6.735a4.845 4.845 0 1 0 0 9.69 4.845 4.845 0 0 0 0-9.69zm0 3.125a1.72 1.72 0 1 1 0 3.44 1.72 1.72 0 0 1 0-3.44z"/>
  </g>`,
};

/**
 * Template function that returns the svg for a given shape type
 * @param {'square'|'circle'|'triangle'|'diamond'|'text'} type - A key matching one of the shape types on {@link BlueprintGraph}
 * @returns {TemplateResult}
 */
export const ToolboxButtonSvgTemplate = type => svg`
  <svg viewBox="0 0 100 100">
    ${contents[type]}
  </svg>
`;
